(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function initTilt(card) {
    const stage = card.closest('.card-3d-stage') || card.parentElement;
    if (!stage) return;
    const isTouch = window.matchMedia('(hover: none)').matches;
    if (isTouch) return; // keep static perspective on mobile

    stage.addEventListener('pointermove', (e) => {
      const rect = stage.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;
      const rotY = (x - 0.5) * -24;
      const rotX = (y - 0.5) * 14;
      card.classList.add('is-tilting');
      card.style.transform = `rotateY(${rotY}deg) rotateX(${rotX}deg)`;
    });
    stage.addEventListener('pointerleave', () => {
      card.classList.remove('is-tilting');
      card.style.transform = 'rotateY(-14deg) rotateX(6deg)';
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.card-3d').forEach(initTilt);
  });
})();
